import { DS_VERSIONS } from 'src/dataLayer/localData/designSystem/versions';

export const getCurrentVersion = () => {
  return DS_VERSIONS.default;
};
